import { useCallback, useContext } from 'react';

import { AppContext } from '../AppContext';
import { getPersonasCookie } from '../utils/persona/personaUtils';

export type UserSnapProfileDecider = (targetCriteria?: string[]) => string[];

/**
 * Hook that returns helper functions for working with a user's snap profile.
 *
 * When triggered have side-effects like reading/setting cookies.
 */
export function useUserSnapProfile(): UserSnapProfileDecider {
  const { cookieManager, personasRef } = useContext(AppContext);

  const getUserSnapProfile = useCallback<UserSnapProfileDecider>(() => {
    // Check for snap personas in app state first
    if (personasRef?.current?.snap !== undefined) {
      return personasRef.current.snap ?? [];
    }

    const personasCookieValue = getPersonasCookie(cookieManager);

    // If there are snap personas in the cookie, return them
    if (personasCookieValue?.snap !== undefined) {
      return personasCookieValue.snap ?? [];
    }

    return [];
  }, [cookieManager, personasRef]);

  return getUserSnapProfile;
}
